import { IApplicationData } from "../../model/application-data";
import { IGetCategoryPublicationRequest } from "../../model/base/request/get-category-publication-request";
import { IGetEntityByMunicipalPortalRequest } from "../../model/base/request/get-entity-by-municipal-portal-request";
import { IGetListSubcategoryPublicationRequest } from "../../model/base/request/get-list-subcategory-publication-request";
import { IGetSubcategoryPublicationRequest } from "../../model/base/request/get-subcategory-publication-request";
import { IBiddingStatusResponse } from "../../model/base/response/bidding-status-response";
import { ICategoryPublicationResponse } from "../../model/base/response/category-publication-response";
import { ICategoryQuestionAwnserResponse } from "../../model/base/response/category-question-awnser-response";
import { IModalityBiddingResponse } from "../../model/base/response/modality-bidding-response";
import { ISubcategoryPublicationResponse } from "../../model/base/response/subcategory-publication-response";
import { IPublishingVehicleResponse } from "../../model/base/response/publishing-vehicle-response";
import { IMenuResponse } from "../../model/base/response/menu-response";
import HttpClient from "../services/http-client";

const defaultPath = 'Base';

const requestApplicationData = async (): Promise<IApplicationData> => {
    var url = window.location.href;

    var multitennantId = 3851;

    if (url.includes("localhost") || url.includes("-sand")) {
        url = "https://www.docgedsistemas.com.br/PortalMunicipio/ba/pmitabuna/home";
    }

    var request = { url } as IGetEntityByMunicipalPortalRequest;

    var applicationData = await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${multitennantId}`,
        params: request
    }).then((response) => Object.assign({} as IApplicationData, response.data));

    setApplicationData(applicationData);

    return applicationData;
};

const getApplicationData = (): IApplicationData | undefined => {
    let value = localStorage.getItem("application_data") as string;
    if (value != null && value != undefined) {
        return JSON.parse(value);
    } else {
        return undefined;
    }
};

const setApplicationData = (data: IApplicationData) => {
    const application = Object.assign({} as IApplicationData, data)
    localStorage.setItem("application_data", JSON.stringify(application));
};

const clearApplicationData = () => {
    localStorage.removeItem("application_data");
};

const getCategoryPublication = async (params: IGetCategoryPublicationRequest): Promise<ICategoryPublicationResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryPublication/${params.id}`,
        params
    }).then((response) => Object.assign({} as ICategoryPublicationResponse, response.data));
};

const getSubCategoryPublication = async (params: IGetSubcategoryPublicationRequest): Promise<ISubcategoryPublicationResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SubcategoryPublication/${params.id}`,
        params
    }).then((response) => Object.assign({} as ISubcategoryPublicationResponse, response.data));
};

const getListSubCategoryPublication = async (params: IGetListSubcategoryPublicationRequest): Promise<ISubcategoryPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SubcategoryPublication`,
        params
    }).then((response) => Object.assign([], response.data));
};

const getListCategporyQuestionAnswer = async (): Promise<ICategoryQuestionAwnserResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryQuestionAnswer`
    }).then((response) => Object.assign([], response.data));
};

const getListModalityBidding = async (): Promise<IModalityBiddingResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ModalityBidding`
    }).then((response) => Object.assign([], response.data));
};
const getListBiddingStatus = async (): Promise<IBiddingStatusResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/BiddingStatus`
    }).then((response) => Object.assign([], response.data));
};

const getListCategoryPublication = async (): Promise<ICategoryPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryPublication`
    }).then((response) => Object.assign([], response.data));
};

const getListPublishingVehicle = async (): Promise<IPublishingVehicleResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PublishingVehicle`
    }).then((response) => Object.assign([], response.data));
};

const requestMenus = async (): Promise<IMenuResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Portal/Menus`
    }).then((response) => Object.assign([], response.data));
};

const BaseAppService = {
    getListBiddingStatus, requestApplicationData, getListCategporyQuestionAnswer, getListModalityBidding, clearApplicationData, getApplicationData, setApplicationData, getCategoryPublication, getListSubCategoryPublication, getSubCategoryPublication, getListCategoryPublication, getListPublishingVehicle, requestMenus
};

export default BaseAppService;